/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActivityWithImpactResponse } from '../models/activity-with-impact-response';
import { BooleanResponse } from '../models/boolean-response';
import { DataAnalyticsActivitiesResponse } from '../models/data-analytics-activities-response';
import { dataAnalyticsCommitments } from '../fn/data-analytics/data-analytics-commitments';
import { DataAnalyticsCommitments$Params } from '../fn/data-analytics/data-analytics-commitments';
import { dataAnalyticsImpacts } from '../fn/data-analytics/data-analytics-impacts';
import { DataAnalyticsImpacts$Params } from '../fn/data-analytics/data-analytics-impacts';
import { dataAnalyticsIndustries } from '../fn/data-analytics/data-analytics-industries';
import { DataAnalyticsIndustries$Params } from '../fn/data-analytics/data-analytics-industries';
import { dataAnalyticsListActivities } from '../fn/data-analytics/data-analytics-list-activities';
import { DataAnalyticsListActivities$Params } from '../fn/data-analytics/data-analytics-list-activities';
import { DataAnalyticsProfileWithCommitmentResponse } from '../models/data-analytics-profile-with-commitment-response';
import { hasAccessToDataAnalytics } from '../fn/data-analytics/has-access-to-data-analytics';
import { HasAccessToDataAnalytics$Params } from '../fn/data-analytics/has-access-to-data-analytics';
import { IndustriesResponse } from '../models/industries-response';

@Injectable({ providedIn: 'root' })
export class DataAnalyticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `hasAccessToDataAnalytics()` */
  static readonly HasAccessToDataAnalyticsPath = '/rest/data-analytics';

  /**
   * Data analytics service to check if logged user has access to data analytics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hasAccessToDataAnalytics()` instead.
   *
   * This method doesn't expect any request body.
   */
  hasAccessToDataAnalytics$Response(params?: HasAccessToDataAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return hasAccessToDataAnalytics(this.http, this.rootUrl, params, context);
  }

  /**
   * Data analytics service to check if logged user has access to data analytics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hasAccessToDataAnalytics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hasAccessToDataAnalytics(params?: HasAccessToDataAnalytics$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.hasAccessToDataAnalytics$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `dataAnalyticsListActivities()` */
  static readonly DataAnalyticsListActivitiesPath = '/rest/data-analytics/activities/{offset}/{limit}';

  /**
   * Data analytics service to list activities with filter, sorting and paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataAnalyticsListActivities()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataAnalyticsListActivities$Response(params: DataAnalyticsListActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<DataAnalyticsActivitiesResponse>> {
    return dataAnalyticsListActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * Data analytics service to list activities with filter, sorting and paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataAnalyticsListActivities$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataAnalyticsListActivities(params: DataAnalyticsListActivities$Params, context?: HttpContext): Observable<DataAnalyticsActivitiesResponse> {
    return this.dataAnalyticsListActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataAnalyticsActivitiesResponse>): DataAnalyticsActivitiesResponse => r.body)
    );
  }

  /** Path part for operation `dataAnalyticsCommitments()` */
  static readonly DataAnalyticsCommitmentsPath = '/rest/data-analytics/commitments/{count}';

  /**
   * Data analytics service to list N last commitments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataAnalyticsCommitments()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsCommitments$Response(params: DataAnalyticsCommitments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataAnalyticsProfileWithCommitmentResponse>>> {
    return dataAnalyticsCommitments(this.http, this.rootUrl, params, context);
  }

  /**
   * Data analytics service to list N last commitments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataAnalyticsCommitments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsCommitments(params: DataAnalyticsCommitments$Params, context?: HttpContext): Observable<Array<DataAnalyticsProfileWithCommitmentResponse>> {
    return this.dataAnalyticsCommitments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DataAnalyticsProfileWithCommitmentResponse>>): Array<DataAnalyticsProfileWithCommitmentResponse> => r.body)
    );
  }

  /** Path part for operation `dataAnalyticsImpacts()` */
  static readonly DataAnalyticsImpactsPath = '/rest/data-analytics/impacts/{count}/{days}';

  /**
   * Data analytics service to list N last impacts in X months.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataAnalyticsImpacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsImpacts$Response(params: DataAnalyticsImpacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityWithImpactResponse>>> {
    return dataAnalyticsImpacts(this.http, this.rootUrl, params, context);
  }

  /**
   * Data analytics service to list N last impacts in X months.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataAnalyticsImpacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsImpacts(params: DataAnalyticsImpacts$Params, context?: HttpContext): Observable<Array<ActivityWithImpactResponse>> {
    return this.dataAnalyticsImpacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityWithImpactResponse>>): Array<ActivityWithImpactResponse> => r.body)
    );
  }

  /** Path part for operation `dataAnalyticsIndustries()` */
  static readonly DataAnalyticsIndustriesPath = '/rest/data-analytics/industries/{count}/{days}';

  /**
   * Data analytics service to list most N most active industries in X days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataAnalyticsIndustries()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsIndustries$Response(params: DataAnalyticsIndustries$Params, context?: HttpContext): Observable<StrictHttpResponse<IndustriesResponse>> {
    return dataAnalyticsIndustries(this.http, this.rootUrl, params, context);
  }

  /**
   * Data analytics service to list most N most active industries in X days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataAnalyticsIndustries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataAnalyticsIndustries(params: DataAnalyticsIndustries$Params, context?: HttpContext): Observable<IndustriesResponse> {
    return this.dataAnalyticsIndustries$Response(params, context).pipe(
      map((r: StrictHttpResponse<IndustriesResponse>): IndustriesResponse => r.body)
    );
  }

}
